// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from '@emotion/styled';
import { string } from 'prop-types';

import ProductGridItemComponent from 'Containers/Products/ProductGridItem';
import useTemplateProducts from './useTemplateProducts';

const State = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-height: 180px;
  padding: 24px;
  border: 1px dashed #cbd5e1;
  color: #64748b;
  background: #f8fafc;
`;

const ProductGridItem = ({ productId }) => {
  const { products, loading, error } = useTemplateProducts(productId ? [productId] : []);

  if (!productId) return <State>Select a product.</State>;
  if (loading) return <State>Loading product…</State>;
  if (error) return <State>Could not load product.</State>;
  if (!products[0]) return <State>Product not found.</State>;

  return (
    <ProductGridItemComponent
      key={ products[0].id }
      product={ products[0] }
      hideQuickView
    />
  );
};

ProductGridItem.propTypes = {
  productId: string,
};

export default ProductGridItem;
